import { Injectable } from '@angular/core';
import { CommonapiService } from '../../Service/Commonapi.service';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ContactPopupService {

constructor(public api: CommonapiService, public httpClient: HttpClient) { }

async GetCustomerDropdownListValues(obj:any,isformupload:boolean) {
  return this.api.apiGet(false, `SalesLogin/GetCustomerDropdownListValues`);    
}
async saveContactPopup(obj: any, isformupload: boolean) {
  return this.api.apiPost(false, `SalesLogin/AddContactPopup`, obj, isformupload);
}

}
